// extracted by mini-css-extract-plugin
module.exports = {"regionAutocompleteSuggestion":"RegionAutocomplete_region-autocomplete-suggestion___5xPE","regionAutocompleteHovering":"RegionAutocomplete_region-autocomplete-hovering__5KL1F"};